export default __webpack_public_path__ + "static/media/icon-telegram.e3274840.svg";